import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Announcement.css";

function Announcement() {
  const [announcements, setAnnouncements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const res = await fetch("https://blog.dietchapter.hosting.acm.org/announcements");
        const data = await res.json();
        setAnnouncements(data);
      } catch (err) {
        console.error("❌ Error fetching announcements:", err);
      }
    };

    fetchAnnouncements();
  }, []);

  return (
    <section id="announcements" className="announcements-section">
      <h2 className="announcements-title">ANNOUNCEMENTS</h2>
      <div className="announcements-list">
        {announcements.map((item) => (
          <div key={item.id} className="announcement-card">
            <img
              src={`https://blog.dietchapter.hosting.acm.org/${item.poster}`}
              alt={item.title}
              className="announcement-img"
            />
            <div className="announcement-content">
              <h3>{item.title}</h3>
              <p>{item.shortDescription}</p>
              <div className="announcement-buttons">
                <button
                  className="details-btn"
                  onClick={() =>
                    navigate(
                      `/announcement/${encodeURIComponent(
                        item.title.replace(/\s+/g, "-")
                      )}`
                    )
                  }
                >
                  See Details
                </button>
                <a
                  href={item.registrationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="register-btn">Register Now</button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Announcement;
